import { LegalLayout, H2, P, UL } from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Términos y Condiciones" updated="2026" testid="page-terminos">
      <P>Las presentes condiciones generales regulan la contratación de los servicios ofrecidos a través del sitio web <b>cyvrlabs.com</b>, titularidad de CYVRLABS, conforme a la Ley 34/2002 (LSSI-CE) y al Real Decreto Legislativo 1/2007 de defensa de consumidores y usuarios.</P>

      <H2>1. Identificación del prestador</H2>
      <UL>
        <li>Titular: CYVRLABS — Ciberseguridad, vulnerabilidades y trabajos de seguridad informática</li>
        <li>NIF: 40967909X</li>
        <li>Domicilio: Apartado de Correos 12345</li>
        <li>Contacto: contacto@cyvrlabs.com</li>
      </UL>

      <H2>2. Objeto y servicios</H2>
      <P>CYVRLABS presta servicios profesionales de ciberseguridad: auditorías y pentesting, monitorización SOC, análisis de vulnerabilidades, OSINT, ciberinteligencia, análisis forense digital y formación en hacking ético. El alcance concreto de cada servicio se detalla en la sección de tarifas y en el presupuesto o contrato específico aceptado por el cliente.</P>

      <H2>3. Proceso de contratación</H2>
      <UL>
        <li>El usuario selecciona el servicio o plan y realiza el pago a través de la pasarela segura de Stripe.</li>
        <li>Una vez confirmado el pago, se activa el servicio contratado (por ejemplo, un análisis prioritario o la vigilancia continua) y/o se contacta con el cliente para planificar los trabajos.</li>
        <li>El idioma de la contratación es el español y el precio se indica en euros (€), impuestos aplicables incluidos según corresponda.</li>
      </UL>

      <H2>4. Precios y facturación</H2>
      <P>Los precios vigentes son los publicados en el sitio en el momento de la contratación. Los pagos únicos y las suscripciones periódicas se procesan mediante Stripe. Las suscripciones se renuevan automáticamente en el periodo indicado hasta que el cliente las cancele.</P>

      <H2>5. Derecho de desistimiento y reembolsos</H2>
      <P>De acuerdo con la normativa de consumidores, en los servicios digitales que comienzan a ejecutarse de inmediato con consentimiento expreso del cliente, el derecho de desistimiento puede no ser aplicable una vez iniciada la prestación. Para solicitudes de cancelación o reembolso, escribe a contacto@cyvrlabs.com; cada caso se valorará conforme a la ley aplicable y al estado de ejecución del servicio.</P>

      <H2>6. Cancelación de suscripciones</H2>
      <P>El cliente puede cancelar la suscripción de vigilancia continua en cualquier momento; la cancelación surte efecto al final del periodo ya facturado, sin nuevos cargos posteriores.</P>

      <H2>7. Obligaciones del cliente</H2>
      <P>El cliente garantiza que dispone de autorización legítima sobre los sistemas objeto de cualquier análisis. El uso de las herramientas de escaneo sobre infraestructuras ajenas sin autorización es ilegal y de exclusiva responsabilidad del usuario.</P>

      <H2>8. Responsabilidad</H2>
      <P>CYVRLABS prestará los servicios con la máxima diligencia profesional, si bien ningún servicio de ciberseguridad garantiza la ausencia total de riesgos. No se responderá de daños derivados del mal uso del servicio por el cliente o de causas de fuerza mayor.</P>

      <H2>9. Legislación aplicable</H2>
      <P>Estas condiciones se rigen por la legislación española. Para cualquier controversia serán competentes los juzgados y tribunales que correspondan conforme a la normativa de protección de consumidores.</P>
    </LegalLayout>
  );
}
